import { global } from "../../constants";

export const data = {
  banner: {
    base: "Services",
    background: global.banner + "ofac.webp",
    title: "OFAC Licenses",
    crumb: "OFAC Licenses"
  },
  icon: "fa-solid fa-file-shield",
  shortDescription:
    "Comprehensive guidance for applying for specific OFAC licenses: regulatory compliance for transactions involving PDVSA and the Venezuelan energy sector.",
  title: "OFAC License Application",
  features: {
    title: "OFAC License Application",
    deliverables: "Deliverables",
    reqDocuments: "Required Documents",
    subtitle:
      "Compliance summary and guidance for transactions in Venezuela's energy sector and operations involving PDVSA.",
    description:
      "Before submitting a specific license application, the company must verify whether its activities are already covered by OFAC General Licenses. Even when an operation could fall under a General License, in practice PDVSA often requires counterparties to hold a specific license before closing the transaction. For that reason, the application should be structured with clear criteria on coverage, party identification, operational scope, payment mechanisms, and supporting documentation.",
    viewDetail: "View Details",
    feats: [
      {
        key: "licencias-generales",
        title: "Verification of Applicable General Licenses",
        summary:
          "We determine whether the proposed activity is already covered by an active General License to avoid unnecessary or misdirected filings.",
        details:
          "We assess the nature of the operation against the General Licenses that may apply to Venezuela's energy sector, including scenarios related to the purchase and export of oil, the supply of goods, technology, or services for exploration and production, the sale of U.S.-origin diluents, and the negotiation of contingent contracts. The analysis clearly distinguishes authorized activities, express limitations, and situations where a separate specific license remains necessary.",
        deliverables: [
          "Coverage analysis under active General Licenses",
          "Reasoned recommendation: general license vs. specific license",
          "OFAC regulatory risk report",
        ],
        requiredDocs: [
          "Description of the proposed activity or transaction",
          "Date of incorporation of the U.S. company",
          "Nature of the good, service, or technology to be provided",
        ],
        icon: "fa-solid fa-shield-halved",
        image: global.ofac + "1.webp",
      },
      {
        key: "solicitante",
        title: "U.S. Applicant Information",
        summary:
          "We gather and structure the applicant's corporate information in line with OFAC requirements.",
        details:
          "The application must precisely identify the applicant: legal name and trade names, state and date of incorporation, principal office and registered address, federal tax ID number, identity of directors and responsible officers, beneficial owners with relevant ownership, corporate structure chart, and any foreign affiliate or related company involved in the transaction.",
        deliverables: [
          "Complete applicant corporate profile",
          "Structured corporate organization chart",
          "List of beneficial owners and directors",
        ],
        requiredDocs: [
          "Certificate of incorporation and bylaws",
          "Identification documents for directors and shareholders",
          "Corporate records of subsidiaries and related entities",
        ],
        icon: "fa-solid fa-building",
        image: global.ofac + "2.webp",
      },
      {
        key: "contraparte-terceros",
        title: "Counterparty and Third-Party Identification",
        summary:
          "We map PDVSA, its affiliates, intermediaries, banks, transport providers, and all other actors involved at any stage of the transaction.",
        details:
          "The application must comprehensively identify the main counterparty and all participating third parties, including affiliates, joint ventures, representatives, agents, intermediaries, financial institutions, transportation or logistics companies, subcontractors, service providers, and Venezuelan government entities with any role in the transaction.",
        deliverables: [
          "Transaction stakeholder mapping",
          "Sanctioned-entity linkage analysis",
          "Third-party due diligence report",
        ],
        requiredDocs: [
          "Contracts or communications with PDVSA or its affiliates",
          "Financial institution and bank account details",
          "Information on involved suppliers, carriers, and agents",
        ],
        icon: "fa-solid fa-sitemap",
        image: global.ofac + "3.webp",
      },
      {
        key: "naturaleza-alcance",
        title: "Nature and Scope of the Operation",
        summary:
          "We define precisely which goods, services, or technology are involved, along with their duration, value, and territorial/operational scope.",
        details:
          "This section documents the detailed description of goods, services, or technology to be provided to or received from PDVSA, their sector classification, how the commercial relationship originated, whether a contract has been signed, the estimated transaction value, duration of the commitment, execution milestones, delivery schedule, and the geographic locations where services will be performed or activities executed.",
        deliverables: [
          "Narrative transaction description for the application",
          "Contract timeline and milestones",
          "Executive summary of technical and commercial scope",
        ],
        requiredDocs: [
          "Draft or signed contract with PDVSA",
          "Technical specifications of goods or services",
          "Preliminary timeline or agreed commercial terms",
        ],
        icon: "fa-solid fa-file-contract",
        image: global.ofac + "4.webp",
      },
      {
        key: "condiciones-pago",
        title: "Payment Terms and Financial Flow",
        summary:
          "We describe how payments will flow, in which currency, through which instruments, and through which banks or financial intermediaries.",
        details:
          "OFAC typically requires a clear explanation of the payment mechanism, whether by wire transfer, letter of credit, offset, barter, or payment in kind. The application should also document payment currency, potential conversion mechanisms, sending and receiving accounts, participating banks, SWIFT codes, and any financial structure associated with the operation.",
        deliverables: [
          "Payment flow diagram with identified institutions",
          "Summary of payment mechanism and applicable currency",
          "Matrix of banks, accounts, and financial participants",
        ],
        requiredDocs: [
          "Complete bank details for all payment entities",
          "Payment instructions or draft financial clauses",
          "Correspondent bank information and SWIFT codes",
        ],
        icon: "fa-solid fa-money-bill-transfer",
        image: global.ofac + "5.webp",
      },
      {
        key: "geografia-documentacion",
        title: "Geographic Scope, Logistics, and Supporting Documentation",
        summary:
          "We organize the territorial and logistical components of the operation together with the document package supporting the application.",
        details:
          "This section should specify where services will be performed, which ports, routes, or countries are involved, and whether oil or derivative exports to third countries are expected. It also consolidates the supporting file with corporate documents, contract or draft contract, technical specifications, payment flow diagram, prior OFAC licenses, and certified translations when required.",
        deliverables: [
          "Operational logistics map with ports, routes, and countries",
          "Complete, organized, and indexed annex package",
          "Documentation checklist for OFAC filing",
        ],
        requiredDocs: [
          "Documentation of transport routes and involved ports",
          "Applicant's prior OFAC licenses, if any",
          "Certified English translations of supporting documents",
        ],
        icon: "fa-solid fa-earth-americas",
        image: global.ofac + "6.webp",
      },
    ],
  },
  ctaText: "Request OFAC Advisory",
  ctaLink: "/contacto?servicio=licencia-ofac",
};